export default "__VITE_ASSET__DasKliZ1__"